import React from "react";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import { Post } from "@radarly/models/posts";
import { Query } from "@radarly/models/queries";
import Matchings from "./matchings";
import Scores from "./scores";

interface IProps {
  post: Post;
  matchings: Query[];
  locale: Locale;
  Footer?: React.ReactNode;
  className?: string;
}

const FooterContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12px;
  text-align: center;
`;

const RadarlyPostMetrics = ({
  post,
  matchings,
  Footer,
  locale,
  className,
}: IProps) => (
  <div className={className} style={{ position: "relative" }}>
    <Scores post={post} locale={locale} />
    <Matchings matchings={matchings} locale={locale} />
    {Footer && <FooterContainer>{Footer}</FooterContainer>}
  </div>
);
export default RadarlyPostMetrics;
